"use client"

import { useRef } from 'react'
import PropTypes from 'prop-types'
import ResourcesSection from '../ResourcesSection/ResourcesSection'
import LevelUpAndTrustSection from '../LevelUpAndTrustSection/LevelUpAndTrustSection'
import { motion, useInView } from 'framer-motion';
import Button from '../global-component/DatasheetButtons';

function formatDateToLong(dateTimeStr) {
    const date = new Date(dateTimeStr.replace(" ", "T")); // Ensure valid ISO format
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}

function ZeroDays({ blok }) {
    const levelUpRef = useRef(null);


    const handleScrollToLevelUp = () => {
        levelUpRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);
    const ref6 = useRef(null);
    const ref7 = useRef(null);

    const isInView1 = useInView(ref1, { once: true, margin: "-100px" });
    const isInView2 = useInView(ref2, { once: true, margin: "-100px" });
    const isInView3 = useInView(ref3, { once: true, margin: "-100px" });
    const isInView4 = useInView(ref4, { once: true, margin: "-100px" });
    const isInView5 = useInView(ref5, { once: true, margin: "-100px" });
    const isInView6 = useInView(ref6, { once: true, margin: "-100px" });
    const isInView7 = useInView(ref7, { once: true, margin: "-100px" });

    const handleDashboardClick = () => {
        window.open(blok?.Content?.[1]?.link?.cached_url, "_blank");
    };

    console.log({ blok })
    return (
        <div className='m-auto bg-asmPageTopBG bg-center bg-cover'>
            {/* <AppBar /> */}
            <div className="relative min-h-[1000px] lg:flex flex-col items-center pt-8 m-auto">
                {/* Header Section */}
                <div className=" font-aileron py-20 lg:py-32 text-center font-bold">
                    <h2 className="bg-custom-radial bg-clip-text text-transparent text-[48px] lg:text-[80px] px-6">
                        {blok.Content[0].header.replace(/\u00A0/g, " ")}
                    </h2>
                    <div className="text-[20px]  m-auto lg:text-[32px] font-normal">
                        {blok.Content[0].subheader}
                    </div>
                    <div className="mt-6 flex justify-center gap-6">
                        <button onClick={handleScrollToLevelUp} className="font-aileron text-[18px] lg:text-[24px] font-normal bg-[#5A27E7] !text-white px-6 py-2 rounded-lg hover:bg-[#483889] lg:w-[255px] lg:h-[64px]">
                            {blok.Content?.[1]?.label}
                        </button>
                    </div>
                </div>

                <div className=''>
                    <div ref={ref1} className="flex flex-col lg:flex-row items-center justify-center lg:gap-10 lg:max-w-7xl mx-auto 
                    z-20 lg:mb-[143px]">
                        <div className="lg:w-[40%] w-[90%]">
                            <motion.div
                                initial={{ opacity: 0, x: -100 }}
                                animate={isInView1 ? { opacity: 1, x: 0 } : {}}
                                transition={{ duration: 0.8, delay: 0.2 }}
                                className="flex justify-center items-center m-auto mb-10 lg:mb-0">
                                <img src={blok?.Content?.[2]?.image?.filename} />
                            </motion.div>
                        </div>

                        <div className="flex flex-col items-center lg:items-start justify-center flex-1">


                            <h2 className="font-aileron text-[28px] text-center lg:text-start lg:text-[48px] 
                                                        !font-bold bg-custom-radial bg-clip-text 
                                                        text-transparent lg:mb-4  mb-4 px-4 lg:px-0 ">
                                {blok?.Content?.[2]?.title}
                            </h2>
                            <p className="font-aileron text-[16px] lg:text-[18px] lg:mb-6 w-[90%] mb-6 mx-auto lg:mx-0 text-center lg:text-start">
                                {blok?.Content?.[2]?.description}
                            </p>
                            {/* <p className="font-aileron text-[16px] lg:text-[18px] lg:mb-6 w-[90%] mb-6 mx-auto lg:mx-0 text-center lg:text-start">
                                {blok.contentText3}
                            </p>
                            <div className="flex justify-center items-center lg:justify-start">
                            <Button title={blok?.DatasheetCta?.[0]?.text} onClick={handleDashboardClick} />
                            </div> */}
                        </div>
                    </div>
                    <div ref={ref2} className="lg:flex justify-center max-w-7xl mx-auto z-20">
                        <div className="flex-1 lg:ml-6">

                            <h2 className="font-aileron text-[28px] text-center lg:text-[48px] !font-bold bg-custom-radial bg-clip-text text-transparent mb-6 lg:mb-4 mt-10 items-center w-[80%] lg:w-[80%] m-auto lg:text-start lg:m-0">
                                {blok?.Content[3]?.title}
                            </h2>
                            <p className="font-aileron text-[16px] lg:text-[18px] mb-6 lg:mb-6 w-[90%] lg:w-[68%] m-auto lg:m-0 text-center lg:text-start">
                                {blok?.Content[3]?.description}
                            </p>
                        </div>
                        <div className="w-full lg:w-auto">
                            <motion.div
                                initial={{ opacity: 0, x: 100 }}
                                animate={isInView2 ? { opacity: 1, x: 0 } : {}}
                                transition={{ duration: 0.8, delay: 0.4 }}
                                className="lg:mt-[-8%] lg:-ml-52 w-[350px] lg:w-[647px] lg:h-[426px] flex justify-center items-center m-auto lg:m-0">
                                <img src={blok?.Content?.[3]?.image?.filename} />
                            </motion.div>
                        </div>
                    </div>
                </div>
                <div ref={ref3} className='flex flex-col justify-center items-center text-center mt-10 w-full max-w-7xl'>
                    <h2 className="font-aileron text-[28px] text-center lg:text-start lg:text-[48px] 
                                                        !font-bold bg-custom-radial bg-clip-text 
                                                        text-transparent lg:mb-[60px]  mb-4 px-4 lg:px-0 ">
                        {blok?.Content?.[4]?.headline}
                    </h2>
                    <div className='grid lg:grid-cols-3 m-auto lg:w-full gap-[50px] px-6 lg:px-0 w-full'>
                        {blok?.Content?.[4]?.cards?.map((card, index) => {
                            return <div
                                key={`zc-${index}`}
                                className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50 w-full">
                                {/* Inner content div */}
                                <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-start items-center text-center py-[40px]">
                                    <p className="font-lato text-[24px] !text-[#49378F] font-bold  mb-2" style={{ color: "#49378F" }}>{card.label}</p>
                                    <img src={card?.icon?.filename} className="h-[95px] w-[95px] mb-6" />
                                    <p className="text-[24px] font-bold font-lato w-[80%]" style={{ color: "#49378F" }}>{card.lead}</p>
                                    <p className="text-[18px] font-lato font-normal w-[80%]">{card.text}</p>
                                    <div className='flex justify-between items-center mt-[69px] gap-[25px]'>
                                        <img src={"/calendar.svg"} className='w-[38px] h-[46.69px] object-cover' />
                                        <p className='text-[24px] font-normal'>{card.date ? formatDateToLong(card.date) : ""}</p>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                    <Button title={blok?.Content?.[5]?.label} onClick={handleDashboardClick} className='mt-[50px]' />
                </div>
                <div className='flex flex-wrap px-6 lg:px-0  max-w-7xl mt-[92px]'>
                    <div className="lg:w-[40%] w-[90%]">
                        <motion.div
                            initial={{ opacity: 0, x: -100 }}
                            animate={isInView1 ? { opacity: 1, x: 0 } : {}}
                            transition={{ duration: 0.8, delay: 0.2 }}
                            className="flex justify-center items-center m-auto mb-10 lg:mb-0">
                            <img src={blok?.Content?.[6]?.image?.filename} />
                        </motion.div>
                    </div>

                    <div className="flex flex-col items-center lg:items-start justify-center flex-1 gap-3 text-center lg:text-left">
                        {
                            blok?.Content?.[6]?.TextList?.map(item => {
                                return <>
                                    <h2 className="font-aileron text-[28px] text-center lg:text-start lg:text-[24px] 
                                                        !font-bold bg-custom-radial bg-clip-text 
                                                        text-transparent px-4 lg:px-0 ">
                                        {item.headline}
                                    </h2>
                                    <p className='mb-3'>
                                        {item.lead}
                                    </p>
                                </>
                            })
                        }
                    </div>
                </div>
                <div className='flex flex-col mt-10 justify-center gap-[28px] items-center mb-[94px]'>
                    <h2 className="font-aileron text-[28px] text-center lg:text-[24px] 
                                                        !font-bold bg-custom-radial bg-clip-text 
                                                        text-transparent px-4 lg:px-0 ">
                        {blok?.Content?.[7].headline}
                    </h2>
                    <div className='border-[#E5E4F9] rounded-[38px] border-[6px] flex lg:flex-row flex-col w-max items-center overflow-hidden flex-wrap'>
                        {blok?.Content?.[7]?.cards?.map((item, index) => {
                            return <div key={`bc-${index}`} className={`flex w-full lg:flex-row flex-col py-[16px] text-[18px] font-bold font-lato  flex-1 gap-[72px] px-6`} style={{ background: item?.background_color?.value, color: item.text_color == "dark" ? "#000000" : "#ffffff", borderLeft: "solid 1px #E5E4F9" }}>
                                <p style={{ color: "inherit" }} className='text-center'>{item.label}</p>
                                <p style={{ color: "inherit" }} className='text-center'>{item.text}</p>
                                <p style={{ color: "inherit" }} className='text-center'>{item.lead}</p>
                            </div>
                        })}
                    </div>
                </div>
                <div className='bg-[linear-gradient(to_right,_#E5E4F9_0%,_#EFD1F2_100%)] py-[44px] flex flex-col justify-center items-center w-full'>
                    <h2 className="font-aileron text-[28px] text-center lg:text-start lg:text-[48px] 
                                                        !font-bold bg-custom-radial bg-clip-text 
                                                        text-transparent px-4 lg:px-0 ">
                                {blok?.Content?.[8 ]?.title}
                            </h2>
                            <Button title={blok?.Content?.[8]?.ctaText} onClick={handleDashboardClick} className='px-[50px] mt-[28px]' />
                    </div>
            </div>
        </div>
    )
}
ZeroDays.propTypes = {
    blok: PropTypes.shape({
        titleText1: PropTypes.string,
        titleText2: PropTypes.string,
        btnText1: PropTypes.string,
        btnText2: PropTypes.string,
        mainImage1: PropTypes.object,
        mainImage2: PropTypes.object,
        contentImage1: PropTypes.object,
        contentImage2: PropTypes.object,
        contentImage3: PropTypes.object,
        contentImage4: PropTypes.object,
        contentImage5: PropTypes.object,
        contentImage6: PropTypes.object,
        contentImage7: PropTypes.object,
        contentText1: PropTypes.string,
        contentText2: PropTypes.string,
        contentText3: PropTypes.string,
        contentText4: PropTypes.string,
        contentText5: PropTypes.string,
        contentText6: PropTypes.string,
        contentText7: PropTypes.string,
        contentText8: PropTypes.string,
        contentText9: PropTypes.string,
        contentText10: PropTypes.string,
        contentText11: PropTypes.string,
        contentText12: PropTypes.string,
        contentText13: PropTypes.string,
        contentText14: PropTypes.string,
        contentText15: PropTypes.string,
        contentText16: PropTypes.string,
        contentText17: PropTypes.string,
        contentText18: PropTypes.string,
        contentText19: PropTypes.string,
        contentText20: PropTypes.string,
        contentText21: PropTypes.string,
        contentText22: PropTypes.string,
        contentText23: PropTypes.string,
        contentText24: PropTypes.string,
        contentText25: PropTypes.string,
        contentText26: PropTypes.string,
        contentText27: PropTypes.string,
        calenderIcon: PropTypes.object,
        resource1Content: PropTypes.string,
        resource2Content: PropTypes.string,
        resource3Content: PropTypes.string,
        resource1Date: PropTypes.string,
        resource2Date: PropTypes.string,
        resource3Date: PropTypes.string,
        resource1Img: PropTypes.object,
        resource2Img: PropTypes.object,
        resource3Img: PropTypes.object,
        resource1Text: PropTypes.string,
        resource2Text: PropTypes.string,
        resource3Text: PropTypes.string,
        resourceUrl1: PropTypes.object,
        resourceUrl2: PropTypes.object,
        resourceUrl3: PropTypes.object
    }).isRequired
};

export default ZeroDays